import { memo } from "react";
import styled from "styled-components";
import useEvent from "react-use/lib/useEvent";
import React, { useRef, useCallback } from "react";
import radius from "../../../helpers/radius";
import { useLabel } from "./state/label";
const Label = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Label",
  componentId: "sc-1ntqwk-0"
})(["", " position:fixed;z-index:1;margin:20px 10px;padding:5px 10px;background-color:rgba(0,0,0,0.9);color:white;font-size:12px;white-space:nowrap;pointer-events:none;"], radius));
const MouseLabel = /*#__PURE__*/memo(() => {
  const ref = useRef();
  const label = useLabel();
  const onMouseMove = useCallback(({
    pageX,
    pageY
  }) => {
    if (ref.current) {
      ref.current.style.top = `${pageY}px`;
      ref.current.style.left = `${pageX}px`;
    }
  }, []);
  useEvent("mousemove", label && onMouseMove);
  if (!label) return false;
  return /*#__PURE__*/React.createElement(Label, {
    ref: ref
  }, label);
});
export default MouseLabel;
//# sourceMappingURL=MouseLabel.js.map